export default class {
  constructor(duration) {
    this.currentTime = 0;
    this.paused = true;
    this.ended = false;
    this.HAVE_CURRENT_DATA = 2;
    this.readyState = 4;
    this.$duration = duration;
    this.$playbackRate = 1;
    this.$prevTime = null;
    this.$prevTimeUpdated = null;
    this.$reqAnimId = null;
    this.$eventList = {
      ended: [],
      timeupdate: [],
      play: [],
      pause: [],
    };
  }

  set duration(duration) {
    this.$duration = duration;
  }

  get duration() {
    return this.$duration;
  }

  set defaultPlaybackRate(speed) {
    this.$playbackRate = speed;
  }

  set playbackRate(speed) {
    this.$playbackRate = speed;
  }

  $dispatch(type) {
    this.$eventList[type].forEach((callback) => { callback.call(this, { target: this }); });
  }

  $ended() {
    if (this.ended) return;
    this.pause();
    this.ended = true;
    this.$dispatch('ended');
  }

  update() {
    const now = Date.now();
    const currentTime = this.currentTime + (((now - this.$prevTime) * this.$playbackRate) / 1000);
    if (currentTime >= this.$duration) {
      this.$ended();
    } else {
      this.currentTime = currentTime;
      if ((now - this.$prevTimeUpdated) > 200) {
        // adjust the timing for mobile controls bar animation
        this.$dispatch('timeupdate');
        this.$prevTimeUpdated = now;
      }
      this.$prevTime = now;
      this.$reqAnimId = requestAnimationFrame(this.update.bind(this));
    }
  }

  play() {
    if (!this.paused) return;
    if (this.ended) {
      this.currentTime = 0;
      this.ended = false;
    }

    this.paused = false;
    const now = Date.now();
    this.$prevTime = now;
    this.$prevTimeUpdated = now;
    this.$reqAnimId = requestAnimationFrame(this.update.bind(this));
    this.$dispatch('play');
  }

  pause() {
    if (this.paused) return;

    this.paused = true;
    cancelAnimationFrame(this.$reqAnimId);
    this.$reqAnimId = null;
    this.$dispatch('pause');
  }

  addEventListener(type, callback) {
    this.$eventList[type].push(callback);
  }

  removeEventListener(type, callback) {
    const index = this.$eventList[type].indexOf(callback);
    if (index !== -1) this.$eventList[type].splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/common/AudioMock.js